const GlobalStyles = (theme) => ({
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  root: {
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  // selectEmpty: {
  //   marginTop: theme.spacing(2),
  // },
  // mainContent: {
  //   display: "grid",
  //   gridTemplateColumns: "25% 25% 25% 25%",
  //   gridColumnGap: "20px",
  //   gridRowGap: "17px",
  //   width: "87%",
  //   margin: "0 auto",
  //   marginLeft: "50px",
  // },
  // vendorProfileMain: {
  //   display: "grid",
  //   gridTemplateColumns: "33% 33% 33%",
  //   gridColumnGap: "20px",
  //   width: "1000px",
  //   margin: "0 auto",
  // },
  // titleText: {
  //   textAlign: "center",
  //   color: "firebrick",
  // },
  // dashboardStatus: {
  //   display: "grid",
  //   gridTemplateColumns: "25% 25% 25% 25%",
  //   gridColumnGap: "10px",
  //   margin: "0 auto",
  //   width: "85%",
  //   fontSize: "1rem",
  // },
  individualStatus: {
    marginBottom: "50px",
    padding: "10px 10px 10px 0px",
    borderRadius: "8px",
    height: "95%",
    border: "1px solid #EEEEEE",
  },
  individualStatusPara: {
    textAlign: "center",
    fontFamily: "Arial, Helvetica, sans-serif",
    color: "#AF0000",
    fontSize: "14px",
  },
  // individualStatusParaLabel: {
  //   color: "#666666",
  //   textAlign: "right",
  //   fontWeight: "bold",
  // },
  // colorstrip: {
  //   width: "2%",
  //   height: "20%",
  //   marginTop: "5%",
  //   border: "1px solid rgba(0,0,0,0.2)",
  //   background: "rgba(0,0,0,0.2)",
  // },
  statusType: {
    marginTop: "-4px",
    marginLeft: "10px",
    fontSize: "16px",
  },
  // statusDiv: {
  //   display: "flex",
  //   marginLeft: "10px",
  // },
  // processComplete: {
  //   background: "#52d663",
  // },
  // individualStatusHelpText: {
  //   gridTemplateColumns: "100%",
  //   fontSize: "12px",
  //   marginBottom: "-15px",
  //   fontFamily: "sans-serif",
  //   textAlign: "left",
  // },
  // fieldHeader: {
  //   width: "35%",
  //   color: "#666666",
  // },
  // fieldStatusHeader: {
  //   width: "35%",
  //   color: "#666666",
  //   marginTop: "-35px",
  // },
  // fieldUserHeader: {
  //   width: "35%",
  //   color: "#666666",
  //   marginTop: "-7px",
  // },
  // fieldData: {
  //   width: "65%",
  //   color: "#333333",
  // },
  // dashboardTemplate: {
  //   display: "flex",
  //   height: "65px",
  // },
  dot: {
    height: "12px",
    width: "12px",
    borderRadius: "50%",
    display: "inline-block",
  },
  statusHelpValue: {
    color: "blue",
  },
  // loginForm: {
  //   width: "600px",
  //   margin: "0 auto",
  //   height: "270px",
  //   marginTop: "75px",
  //   background: "white",
  //   marginBottom: "75px",
  //   boxShadow: "3px 3px 8px 0px #e11a2b",
  //   borderRadius: "10px",
  //   display: "grid",
  // },
  username: {
    width: "80%",
    margin: "0 auto",
  },
  password: {
    width: "80%",
    margin: "0 auto",
  },
  // loginButton: {
  //   width: "150px",
  //   background: "transparent",
  //   height: "35px",
  //   margin: "0 95%",
  //   color: "black",
  //   marginTop: "0px",
  //   border: "1px solid black",
  //   fontSize: "18px",
  //   fontWeight: "bold",
  // },
  statusList: {
    display: "grid",
    gridTemplateColumns: "85% 15%",
    background: "#e6e6e6",
    padding: "10px",
    borderRadius: "5px",
  },
  // landingTable: {
  //   paddingTop: "35px",
  // },
  // landingPageTitle: {
  //   color: "black",
  //   fontSize: "18px",
  //   fontFamily: "sans-serif",
  //   fontVariant: "all-petite-caps",
  // },
  // vendorVariousStatus: {
  //   width: "112px",
  //   padding: "5px",
  //   borderRadius: "5px",
  // },
  filters: {
    display: "flex",
    width: "100%",
  },
  heading: {
    fontSize: "1rem",
    color: "brown",
    width: "33%",
    marginLeft: "15px",
  },
  applyFilter: {
    background: "#e01a2b",
    color: "white",
    float: "right",
    margin: "5px",
  },
  clearFilter: {
    border: "1px solid black",
    color: "black",
    float: "right",
    margin: "5px",
  },
  // filterByDun: {
  //   padding: "15px",
  //   borderRadius: "6px",
  //   display: "grid",
  //   gridTemplateColumns: "25% 40% 25%",
  //   gridColumnGap: "30px",
  //   background: "#e6e6e6",
  // },
  // enterDun: {
  //   padding: "10px",
  //   fontSize: "1rem",
  //   fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  //   color: "#000000bf",
  //   marginLeft: "15px",
  //   width: "25%",
  // },
  // expansionHeading: {
  //   display: "grid",
  //   gridTemplateColumns: "25% 25% 25%",
  // },
  // dunsAndName: {
  //   fontSize: "14px",
  //   color: "black",
  //   background: "lightgrey",
  //   padding: "8px",
  // },
  // buttonStyle: {
  //   background: "brown",
  //   height: "35px",
  //   marginTop: "25px",
  //   width: "120px",
  //   color: "white",
  //   float: "right",
  //   marginRight: "100px",
  // },
  // filterChannel: {
  //   border: "none",
  //   padding: "5px",
  //   borderRadius: "4px",
  // },
  topNav: {
    display: "grid",
    gridTemplateColumns: "15% 15% 15% 15% 35% 15%",
    listStyleType: "none",
    textDecoration: "none",
    background: "rgba(0,0,0,0.5)",
    padding: "8px",
    marginTop: "-20px",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "15px",
  },
  // vendorNameSelect: {
  //   borderRadius: "5px",
  //   width: "77%",
  // },
  // tableLayout: {
  //   width: "100%",
  //   overflowY: "scroll",
  //   height: "350px",
  // },
  dunsLink: {
    color: "blue",
  },
  // successfulVendor: {
  //   color: "limegreen",
  //   fontFamily: "sans-serif",
  //   fontSize: "18px",
  //   textAlign: "center",
  //   marginBottom: "-28px",
  // },
  // closeDialog: {
  //   width: "20%",
  //   padding: "10px",
  //   borderRadius: "5px",
  //   border: "none",
  //   marginTop: "10px",
  //   marginLeft: "82%",
  // },
  disabled: {
    pointerEvents: "none",
    background: "rgba(0,0,0,0.2)",
    padding: "6px",
    borderRadius: "5px",
    border: "none",
    width: "100%",
    background: "white",
  },
  // addMoreVendors: {
  //   color: "white",
  //   background: "black",
  // },
  updateVendor: {
    color: "black",
    background: "lightgray",
  },
  completed: {
    width: "2%",
    height: "20%",
    marginTop: "5%",
    border: "1px solid limegreen",
    background: "limegreen",
  },
  // completedStep: {
  //   color: "limegreen",
  //   textAlign: "right",
  //   fontWeight: "bold",
  // },
  // exportButton: {
  //   width: "35%",
  //   background: "firebrick",
  //   color: "white",
  //   padding: "9px",
  //   borderRadius: "5px",
  //   margin: "8px 5px 0px 10px",
  // },
  reportingTable: {
    textAlign: "center",
    fontFamily: "sans-serif",
    width: "100%",
    "& td": {
      padding: "8px",
      fontSize: "0.8rem",
    },
    "& th": {
      padding: "8px",
      fontSize: "0.8rem",
      textAlign: "center",
      backgroundColor: "#d06060",
      color: "white",
    },
    "& tr:nth-child(even)": {
      backgroundColor: "#f500570a",
    },
  },
  // imgIcon: {
  //   marginTop: "-5px",
  //   width: "155px",
  //   height: "75px",
  // },
  // stickyPosition: {
  //   position: "sticky",
  //   top: "0px",
  //   zIndex: "100",
  //   background: "white",
  //   marginBottom: "15px",
  //   marginTop: "20px",
  // },
  // stickyPositionNav: {
  //   position: "sticky",
  //   top: "73px",
  //   zIndex: "99999",
  //   background: "white",
  // },
  // myHeaderClass: {
  //   width: "100%",
  //   color: "#fff",
  //   backgroundColor: "#626369",
  //   cursor: "pointer",
  // },
  // myTableClass: {
  //   border: "1px solid grey",
  //   fontSize: "15px",
  //   overflow: "scroll",
  //   maxHeight: "400px",
  //   borderRadius: "5px",
  // },
  // myHeaderContainer: {
  //   position: "sticky",
  //   top: "0px",
  // },
  // myTrClass: {
  //   lineHeight: "30px",
  // },
  // myContainerClass: {
  //   width: "100%",
  // },
  // myTableBodyClass: {
  //   width: "100%",
  // },
  // modifyOrCancel: {
  //   width: "22%",
  //   height: "25px;",
  //   border: "none",
  //   borderRadius: "5px",
  //   background: "#3f51b58c",
  //   marginTop: "14px",
  //   fontSize: "10px",
  //   color: "white",
  // },
  // updateStatusDail: {
  //   cursor: "pointer",
  //   border: "1px solid lightgray",
  //   padding: "9px",
  //   background: "#f2f2f2",
  //   height: "125px",
  //   borderRadius: "5px",
  // },
  mandateStar: {
    color: "red",
  },
  sendMail: {
    background: "#3f51b58c",
    marginLeft: "187px",
    padding: "3px",
    fontSize: "10px",
    color: "white",
    marginTop: "-98px",
  },
  // upsSection: {
  //   marginLeft: "4%",
  //   padding: "1%",
  //   background: "beige",
  //   width: "89%",
  //   borderRadius: "5px",
  // },
  // upsSectionContainer: {
  //   display: "grid",
  //   padding: "9% 7% 0 7%",
  //   gridTemplateColumns: "50% 50%",
  //   marginTop: "-8%",
  // },
  upload: {
    paddingTop: "10px",
    paddingBottom: "10px",
    background: "beige",
  },
  // freezeFirstColumn: {
  //   position: "sticky",
  //   zIndex: "9999",
  //   left: "-25px",
  //   border: "1px solid white",
  //   top: "-19px",
  // },
  // freezeSecondColumn: {
  //   position: "sticky",
  //   zIndex: "9999",
  //   left: "58.5px",
  //   border: "1px solid white",
  //   top: "-19px",
  // },
  // freezeHeader: {
  //   position: "sticky",
  //   zIndex: "999",
  //   top: "-19px",
  // },
  // disableWidget: {
  //   pointerEvents: "none",
  // },
  disableButton: {
    pointerEvents: "none",
    padding: "10px",
    background: "rgba(0,0,0,0.07)",
    borderRadius: "6px",
    textDecoration: "none",
    color: "grey",
    marginTop: "8px",
    marginRight: "12px",
    width: "33%",
    fontFamily: "sans-serif",
    fontSize: "13px",
  },
  unAuthorized: {
    width: "600px",
    margin: "0 auto",
    height: "165px",
    marginTop: "75px",
    background: "white",
    marginBottom: "75px",
    boxShadow: "3px 3px 8px 0px gray",
    borderRadius: "10px",
    display: "grid",
    textAlign: "center",
  },
  textSly: {
    color: "red",
    fontVariantCaps: "all-petite-caps",
    textAlign: "center",
    fontSize: "1.3rem",
  },
  filterContent: {
    paddingLeft: "7%",
    paddingRight: "7%",
    border: "1px solid lightgray",
    height: "225px",
    width: "79%",
    margin: "0px auto",
    borderRadius: "8px",
  },
  goBackButton: {
    height: "30px",
    width: "auto",
    margin: "0 auto",
    border: "none",
    background: "none",
    color: "blue",
  },
  // addNewVendorContainer: {
  //   display: "flex",
  //   flexDirection: "column",
  //   width: "65%",
  //   margin: "0 auto",
  // },
  // addNewVendorButton: {
  //   display: "flex",
  //   flexDirection: "column",
  //   width: "65%",
  //   margin: "0 auto",
  //   background: "#e01a2b",
  //   marginTop: "10px",
  //   color: "white",
  // },
  // logoutContainer: {
  //   float: "right",
  //   fontFamily: "sans-serif",
  // },
  // generalContainer: {
  //   background: "radial-gradient(#c2b9bb0a, transparent)",
  //   padding: "2%",
  //   margin: "0 auto",
  //   width: "40%",
  //   padding: "2%",
  //   borderRadius: "10px",
  //   border: "1px solid",
  // },
  // vendorTextContainer: {
  //   display: "grid",
  //   gridTemplateColumns: "38% 38%",
  //   padding: "15px",
  // },
  // vendorCheckboxContainer: {
  //   padding: "15px",
  //   width: "76%",
  // },
  addressCheckbox: {
    display: "grid",
    gridTemplateColumns: "25% 25% 25%",
    padding: "15px",
  },
  backdrop: {
    height: "100%",
    width: "100%",
    position: "fixed",
    top: "0",
    left: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: "100",
  },
  // uploader: {
  //   zIndex: "200",
  // },
  // uploadContainer: {
  //   padding: "10px",
  //   borderRadius: "7px",
  //   margin: "10px",
  // },
  // vendorUploadButton: {
  //   border: "1px solid",
  //   padding: "5px",
  //   borderRadius: "4px",
  //   background: "#6d6b6c",
  //   color: "white",
  //   fontSize: "0.9rem",
  // },
  // addImg: {
  //   marginLeft: "10px",
  //   marginRight: "10px",
  // },
  // uploadInput: {
  //   padding: "10px",
  //   borderRadius: "7px",
  //   margin: "5px",
  //   border: "1px solid lightgrey",
  //   width: "52%",
  // },
  // logoutButton: {
  //   background: "black",
  //   color: "white !important",
  //   border: "none",
  //   "& hover": {
  //     background: "black",
  //   },
  // },
  errorIcon: {
    width: "30px",
    marginRight: "10px",
    marginTop: "-8px",
  },
  // displayInLine: {
  //   display: "inline-flex",
  //   padding: "10px",
  // },
  // displayCenter: {
  //   width: "77%",
  //   margin: "0 auto",
  // },
  // imgUserIcon: {
  //   width: "80px",
  //   borderRadius: "35px",
  // },
  // signInMacysLogo: {
  //   width: "165px",
  //   marginBottom: "10px",
  // },
  // liveTileInternal: {
  //   marginTop: "-34px",
  //   width: "75%",
  //   wordBreak: "break-word",
  //   fontSize: "0.85rem",
  //   marginLeft: "10px",
  // },
  // signInWatermark: {
  //   height: "72vh",
  //   margin: "6% 0% 0% 0%",
  //   boxShadow: "-2px 9px 17px #0000004d",
  //   //backgroundImage: url("public/macys-build.jpg")
  // },
  // loginMain: {
  //   width: "60%",
  //   float: "left",
  // },
  // loginRight: {
  //   width: "38%",
  //   float: "left",
  // },
  // loginContent: {
  //   padding: "16% 9%",
  //   marginRight: "5px",
  // },
  // signinHeader: {
  //   fontSize: "35px",
  //   fontWeight: 500,
  //   fontFamily: 'Lato, "Helvetica Neue", Arial, Helvetica, sans-serif',
  //   display: "inline-block",
  //   position: "relative",
  //   top: "0px",
  //   left: "-1px",
  // },
  // logonBtn: {
  //   display: "block",
  //   padding: "10px 35px !important",
  //   fontSize: "20px !important",
  //   fontFamily: "Helvetica, sans-serif",
  //   borderRadius: "5px !important",
  //   position: "relative",
  //   top: "0px",
  //   left: "70%",
  //   backgroundColor: "#c30d1d !important",
  //   color: "white !important",
  //   boxShadow: "4px 6px 9px #00000",
  //   marginLeft: "0%",
  // },
  // signinIcon: {
  //   marginTop: "-4px",
  //   width: "27px",
  // },
  // loginMenu: {
  //   top: "-15%",
  //   float: "right",
  //   transform: "translate(690%, 5%)",
  //   position: "absolute",
  // },
  // loginMainNav: {
  //   color: "#3f48cc",
  //   fontWeight: "700",
  //   fontSize: "12px",
  //   textDecoration: "underline !important",
  // },
});

export default GlobalStyles;
